module.exports = __webpack_public_path__ + "img/zhifibao.0cd7d72a.jpg";